export default {
  setBuses(state, payload) {
    state.buses = payload;
  },
};
